import * as React from 'react';
import { IStackTokens, Stack, FocusZone } from '@fluentui/react';

import AnalyticsFilterList from './AnalyticsFilterList';
import { AnalyticsField, AnalyticsFieldFilter } from './AnalyticsModel';

interface Props {
  criteriaInput: AnalyticsFieldFilter;
  updateCriteriaInParent: Function;
  allAVFields: AnalyticsField[];
  tagOptions: any[];
  assignedTeam: any[];
}

const WorkItemTab: React.FC<Props> = (props) => {
  const [fieldsList, setFieldsList] = React.useState<AnalyticsFieldFilter>(props.criteriaInput);
  const stackTokens: IStackTokens = { childrenGap: 15 };

  React.useEffect(() => {
    if (fieldsList !== undefined) {
      props.updateCriteriaInParent(fieldsList);
    }
  }, [fieldsList]);

  const updateCriteriaInParent1 = (viewCriteria: AnalyticsFieldFilter) => {
    setFieldsList({ ...viewCriteria });
  };

  return (
    <>
      <div className='ms-Grid'>
        <Stack tokens={stackTokens} className='marginLeft8px'>
          <div>
            <FocusZone>
              <div className='paddingRight30px'>
                <div className='height15'></div>
                <Stack tokens={stackTokens}>
                  <div className='ms-Grid-row'>
                    <div className='ms-Grid-col ms-lg12'>
                      <div className='height15'></div>
                      <div>
                        Work items type: <b>Action</b>
                      </div>
                      <div className='height15'></div>
                      <div>
                        Filter the data that appears in this view by field criteria. Only work items
                        that meet all of the conditions will be in the view.
                      </div>
                      <div className='height15'></div>
                      <AnalyticsFilterList
                        fieldsList={fieldsList}
                        avFields={props.allAVFields}
                        tagsOptions={props.tagOptions}
                        assignedTeam={props.assignedTeam}
                        updateCustomQueryData={updateCriteriaInParent1}></AnalyticsFilterList>
                    </div>
                  </div>
                </Stack>
              </div>
            </FocusZone>
          </div>
          <div className='height30'></div>
        </Stack>
      </div>
    </>
  );
};

export default WorkItemTab;
